/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const aPIImportUserOneUsernameMax = 150;

export const aPIImportUserOneUsernameRegExp = new RegExp('[\\w.@+-]+');
export const aPIImportUserOneFirstNameMax = 150;

export const aPIImportUserOneLastNameMax = 150;

export const aPIImportAppVersionMax = 25;

export const APIImport = zod.strictObject({
    created_at: zod.number(),
    user: zod
        .strictObject({
            id: zod.number(),
            username: zod
                .string()
                .max(aPIImportUserOneUsernameMax)
                .regex(aPIImportUserOneUsernameRegExp)
                .describe(
                    'Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.',
                ),
            first_name: zod
                .string()
                .max(aPIImportUserOneFirstNameMax)
                .optional(),
            last_name: zod.string().max(aPIImportUserOneLastNameMax).optional(),
        })
        .nullable(),
    import_type: zod
        .union([
            zod
                .enum(['orgUnit', 'instance', 'bulk', 'storageLog'])
                .describe(
                    '\* `orgUnit` - Org Unit\n\* `instance` - Form instance\n\* `bulk` - Bulk Org Units and Instances\n\* `storageLog` - Storage logs',
                ),
            zod.enum(['']),
            zod.literal(null),
        ])
        .nullish(),
    json_body: zod.unknown(),
    headers: zod.unknown(),
    has_problem: zod.boolean().optional(),
    file: zod.url().nullish(),
    app_id: zod.string().optional(),
    app_version: zod.string().max(aPIImportAppVersionMax).optional(),
    exception: zod.string().optional(),
});

export type APIImport = zod.input<typeof APIImport>;
export type APIImportOutput = zod.output<typeof APIImport>;
